import React from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import servicesButtonPattern from "images/patterns/services-button-pattern.svg";
import { Link } from "gatsby-plugin-intl";

const ServiceCard = ({
  title,
  description,
  btnText,
  animationSrc,
  path,
  onButtonClick,
}) => {
  return (
    <div className="w-full max-w-90p md:w-1/2 lg:w-1/4 mb-24 justify-between px-3">
      <div
        className="bg-white pt-6 mx-auto rounded-lg rounded-b-1xl flex flex-col h-full"
        style={{ boxShadow: "0px 7px 20px rgba(0, 0, 0, 0.07)" }}
      >
        <div className="h-56 inline-block mx-auto px-3">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video
            className="h-full"
            controls={false}
            autoPlay
            playsInline
            loop
            muted
          >
            <source src={animationSrc} type="video/mp4" />
          </video>
        </div>
        <div className="px-6">
          <div className="text-center text-xl mt-2 font-bold mb-3">
            <span className="text-primary">{title}</span>
          </div>
          <div
            style={{ fontSize: "1rem" }}
            className="mb-16 text-center opacity-75 leading-7"
          >
            {description}
          </div>
        </div>
        <div className="mt-auto">
          <Button
            className="service-card-button mx-auto w-full uppercase rounded-t-none pt-3 pb-3 rounded-b-1xl"
            variant="default"
            style={{
              backgroundImage: `url(${servicesButtonPattern})`,
            }}
            component={path ? Link : undefined}
            to={path || undefined}
            onClick={onButtonClick}
          >
            {btnText}
          </Button>
        </div>
      </div>
    </div>
  );
};

ServiceCard.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  description: PropTypes.string,
  btnText: PropTypes.string,
  animationSrc: PropTypes.string,
  onButtonClick: PropTypes.func,
};

export default ServiceCard;
